import {
  List,
  Empty,
  Card,
  Button,
  Divider,
} from 'antd';
import moment from 'moment';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import {
  INotice,
  INoticeDetail,
} from '@/presentation/layouts/header/notice/index';
import style from './notice-list.module.scss';

interface IProps {
  data: INotice[];
  onReadNotice: (id: string) => void;
}

export const NoticeList: FC<IProps> = (props) => {
  const { t } = useTranslation();
  const { data = [], onReadNotice } = props;

  const replaceURLWithHTMLLinks = (text: string) => {
    const exp = /(\b(https?|ftp|file):\/\/[-A-Z0-9+&@#/%?=~_|!:,.;]*[-A-Z0-9+&@#/%=~_|])/gi;
    return text.replace(exp, `<a target='_blank' href='$1'>${t('详情链接')}</a>`);
  };

  const renderItem = (item: INotice) => <List.Item className={style.messageItem}>
    <Card
      title={item.title}
      extra={item.readFlag === '0' && <Button type='primary' ghost onClick={() => onReadNotice(item.noticeId)}>{t('我知道了')}</Button>}
      bordered={false}
    >
      {item.noticeDetailList?.map((detail: INoticeDetail, index: number) => (
        <div key={index} className={style.messageItemContent}>
          <div className={style.messageItemSubTitle}>{detail.subTitle}</div>
          <div
            className={style.messageItemSubContent}
            dangerouslySetInnerHTML={{ __html: replaceURLWithHTMLLinks(detail.content) }}
          />
        </div>
      ))}
    </Card>
    <p className={style.messageItemDate}>{moment(item.updateTime).format('YYYY-MM-DD')}</p>
    <Divider/>
  </List.Item>;

  return <List
    locale={{ emptyText: <Empty description={t('当前无消息')} /> }}
    grid={{ gutter: 16, column: 1 }}
    dataSource={data}
    renderItem={renderItem}
  />;
};
